import { render, staticRenderFns } from "./ScrapDrawer.vue?vue&type=template&id=3c94b2ce&scoped=true&"
import script from "./ScrapDrawer.vue?vue&type=script&lang=js&"
export * from "./ScrapDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94b2ce",
  null
  
)

export default component.exports